/**
 * Live Orders palette.
 *
 * Surfaces and text are the ground's CSS variables (theme/grounds.ts), so the
 * board sits on whichever ground the admin is on — a column is a sunk panel, a
 * card a panel, as in the reskin prototype. The phase accents (mint / orange /
 * blue / amber / red / green) are unchanged — they're the shared language with
 * the shop tablet and the Orders Centre status chips, so they must stay
 * identical, and stay literal hex so hexA() can tint them.
 */
export const tablet = {
  bg: 'var(--canvas)', card: 'var(--panel)', surface: 'var(--sunk)', line: 'var(--line)',
  ink: 'var(--tx)', muted: 'var(--tx2)', faint: 'var(--tx3)',
  mint: '#34eec1', mintInk: '#06231d', orange: '#ff6a3d', blue: '#2f6bff',
  amber: '#f5a623', red: '#ff4d54', green: '#16b981', banner: '#0d66bb', white: '#ffffff',
  radius: 10, radiusSm: 8,
} as const;

export function hexA(hex: string, a: number): string {
  if (!hex.startsWith('#')) throw new Error(`hexA needs a hex colour, got ${hex}`);
  const h = hex.replace('#', '');
  return `rgba(${parseInt(h.slice(0, 2), 16)},${parseInt(h.slice(2, 4), 16)},${parseInt(h.slice(4, 6), 16)},${a})`;
}

export const money = (n: number): string =>
  'R' + n.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function minutesSince(iso: string | null | undefined): number {
  if (!iso) return 0;
  return Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
}

export function orderCode(num: string | null, id: string): string {
  return String(num ?? id).replace(/[^A-Za-z0-9]/g, '').slice(-4).toUpperCase() || '----';
}

export function timerColor(minutes: number, terminal: boolean): string {
  if (terminal) return tablet.faint;
  if (minutes > 20) return tablet.red;
  if (minutes > 11) return tablet.amber;
  return tablet.muted;
}
